// src/layouts/components/dashboard/DashboardProjectsSection.jsx

import { useAuth } from "../../../auth/authContext";
import useMyProjects from "../../../features/projects/hooks/useMyProjects";
import ProjectParticipationCard from "../../../features/projects/components/ProjectParticipationCard";
import {
  ApplicationSectionHeader,
  ApplicationStateRegion,
} from "../../../components/application";

export default function DashboardProjectsSection({
  headingLevel = 2
} = {}) {
  const { user } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
  const {
    myProjects,
    loadingProjects,
    projectsError,
  } = useMyProjects({ token: user?.token, apiUrl });

  if (loadingProjects) {
    return (
      <section
        aria-labelledby="dashboard-projects-title"
        className="av-dashboard-projects"
      >
        <ApplicationSectionHeader
          headingLevel={headingLevel}
          title="Your projects"
          titleId="dashboard-projects-title"
          variant="compact"
        />
        <ApplicationStateRegion
          message="Loading your projects..."
          status="loading"
        />
      </section>
    );
  }

  if (projectsError) {
    return (
      <section
        aria-labelledby="dashboard-projects-title"
        className="av-dashboard-projects"
      >
        <ApplicationSectionHeader
          headingLevel={headingLevel}
          title="Your projects"
          titleId="dashboard-projects-title"
          variant="compact"
        />
        <ApplicationStateRegion
          message="Could not load your projects."
          status="error"
        />
      </section>
    );
  }

  return (
    <section
      aria-labelledby="dashboard-projects-title"
      className="av-dashboard-projects"
    >
      <ApplicationSectionHeader
        headingLevel={headingLevel}
        title="Your projects"
        titleId="dashboard-projects-title"
        variant="compact"
      />

      {myProjects.length > 0 ? (
        <div className="av-dashboard-projects__grid">
          {myProjects.map((project) => (
            <ProjectParticipationCard
              key={project.id || project.slug}
              project={project}
            />
          ))}
        </div>
      ) : (
        <ApplicationStateRegion
          message="No assigned projects yet."
          status="empty"
        />
      )}

    </section>
  );
}
